const _Password = {
  options: {
    minChar: 5, // too short while less than this

    passIndex: 2, // Weak, 0 indexed

    verdicts: [
      'too short',
      'very weak',
      'weak',
      'good',
      'strong',
      'very strong'
    ],

    // tweak scores here
    scores: [10, 20, 30, 45],

    // when in banned list, verdict is:
    bannedPass: 'not allowed, too common',

    finalCheck: pass => true,

    // when final check failed, verdict is:
    finalCheckFailed: 'failed requirements'
  },

  bannedPasswords: [
    // see study here: https://github.com/danielmiessler/SecLists/blob/master/Passwords/10_million_password_list_top_100.txt
    '123456',
    'password',
    '12345678',
    'qwerty',
    '123456789',
    '12345',
    '1234',
    '111111',
    '1234567',
    'dragon',
    '123123',
    'baseball',
    'abc123',
    'football',
    'monkey',
    'letmein',
    '696969',
    'shadow',
    'master',
    '666666',
    'qwertyuiop',
    '123321',
    'mustang',
    '1234567890',
    'michael',
    '654321',
    'pussy',
    'superman',
    '1qaz2wsx',
    '7777777',
    'fuckyou',
    '121212',
    '000000',
    'qazwsx',
    '123qwe',
    'killer',
    'trustno1',
    'jordan',
    'jennifer',
    'zxcvbnm',
    'asdfgh',
    'hunter',
    'buster',
    'soccer',
    'harley',
    'batman',
    'andrew',
    'tigger',
    'sunshine',
    'iloveyou',
    'fuckme',
    '2000',
    'charlie',
    'robert',
    'thomas',
    'hockey',
    'ranger',
    'daniel',
    'starwars',
    'klaster',
    '112233',
    'george',
    'asshole',
    'computer',
    'michelle',
    'jessica',
    'pepper',
    '1111',
    'zxcvbn',
    '555555',
    '11111111',
    '131313',
    'freedom',
    '777777',
    'pass',
    'fuck',
    'maggie',
    '159753',
    'aaaaaa',
    'ginger',
    'princess',
    'joshua',
    'cheese',
    'amanda',
    'summer',
    'love',
    'ashley',
    '6969',
    'nicole',
    'chelsea',
    'biteme',
    'matthew',
    'access',
    'yankees',
    '987654321',
    'dallas',
    'austin',
    'thunder',
    'taylor',
    'matrix'
  ],

  checks: [
    /* alphaLower */ {
      re: /[a-z]/,
      score: 1
    },
    /* alphaUpper */ {
      re: /[A-Z]/,
      score: 2
    },
    /* mixture of upper and lowercase */ {
      re: /([a-z].*[A-Z])|([A-Z].*[a-z])/,
      score: 5
    },
    /* threeNumbers */ {
      re: /(.*[0-9].*[0-9].*[0-9])/,
      score: 7
    },
    /* special chars */ {
      re: /.[!@#$%^&*?_~]/,
      score: 5
    },
    /* multiple special chars */ {
      re: /(.*[!@#$%^&*?_~].*[!@#$%^&*?_~])/,
      score: 7
    },
    /* all together now, does it look nice? */ {
      re: /([a-zA-Z0-9].*[!@#$%^&*?_~])|([!@#$%^&*?_~].*[a-zA-Z0-9])/,
      score: 3
    },
    /* password of a single char sucks */ {
      re: /(.)\1+$/,
      score: 2
    }
  ],

  check: function (password) {
    let index = 0
    let verdict
    const score = this._checkPassword(password)
    const o = this.options
    const s = o.scores.slice()

    if (this.bannedPasswords.indexOf(password.toLowerCase()) !== -1) {
      verdict = o.bannedPass
    } else {
      if (score >= 0 || score <= -199) {
        s.push(score)
        s.sort(function (a, b) {
          return a - b
        })
        index = s.indexOf(score) + 1
      }

      verdict = o.verdicts[index] || o.verdicts[o.verdicts.length - 1]
    }

    let pass = index >= o.passIndex
    if (!o.finalCheck(password)) {
      pass = false
      verdict = o.finalCheckFailed
    }

    return {
      verdict,
      pass,
      score,
      index,
      password
    }
  },

  _checkPassword: function (pass) {
    let score = 0
    const { minChar } = this.options
    const len = pass.length
    const diff = len - minChar

    // pass length bonuses or penalties
    if (diff < 0) score -= 100
    if (diff >= 5) score += 18
    if (diff >= 3) score += 12
    if (diff === 2) score += 6

    this.checks.forEach(check => {
      if (pass.match(check.re)) score += check.score
    })

    // extra bonus for length per char
    if (score) score += len
    return score
  }
}

/** @type {import("../interfaces").PasswordFactory} */
const PasswordFactory = Object.assign(
  /**
   * @param {import("../interfaces").PasswordOptions} o
   * @returns {import("../interfaces").Password}
   */
  function Password (o) {
    const { check, _checkPassword, bannedPasswords, options, checks } = _Password
    return {
      options: { ...options, ...o },
      check,
      _checkPassword,
      bannedPasswords: bannedPasswords.slice(),
      checks: checks.map(check => ({ ...check }))
    }
  },
  _Password
)

export default PasswordFactory
